import { Activity } from '../types/activity';

/**
 * Zonen-Gewichte (Punkte pro Minute) – spiegelt backend/services/ScoringEngine.php v6
 * Zone 0 (Ruhezone):    0.00  →  0 Pkt/h
 * Zone 1 (Regeneration): 0.50–0.70 (linear interpoliert)
 * Zone 2 (Grundlagen):   0.90–1.10 (linear interpoliert)
 * Zone 3 (Tempo):        1.10–1.30 (linear interpoliert)
 * Zone 4 (Schwelle):     1.30–1.50 (linear interpoliert)
 * Zone 5 (Anaerob):      1.50–1.70 (linear interpoliert)
 */
export const ZONE_WEIGHTS = [0.60, 1.00, 1.20, 1.40, 1.60] as const;

/** Lineare Gewichtungs-Anchorpunkte: [ZoneStart, WeightStart, ZoneEnd, WeightEnd] */
export const LINEAR_WEIGHTS: [number, number, number, number][] = [
  [0.00, 0.00, 0.00, 0.00], // Z0: immer 0.00
  [0.50, 0.50, 0.70, 0.70], // Z1: 0.50 → 0.70
  [0.90, 0.90, 1.10, 1.10], // Z2: 0.90 → 1.10
  [1.10, 1.10, 1.30, 1.30], // Z3: 1.10 → 1.30
  [1.30, 1.30, 1.50, 1.50], // Z4: 1.30 → 1.50
  [1.50, 1.50, 1.70, 1.70], // Z5: 1.50 → 1.70
];

/**
 * Zonen-Grenzen in % von maxHR (keine Überschneidungen, 0.1% Lücke)
 */
export const ZONE_PERCENTAGES: [number, number][] = [
  [0.0, 50.0],   // Z0: 0% - 50.0%
  [50.1, 65.0],  // Z1: 50.1% - 65.0%
  [65.1, 80.0],  // Z2: 65.1% - 80.0%
  [80.1, 87.5],  // Z3: 80.1% - 87.5%
  [87.6, 95.0],  // Z4: 87.6% - 95.0%
  [95.1, 100.0], // Z5: 95.1% - 100%+
];

/** Pauschaler Ersatz-Faktor ohne Pulsgurt (Punkte/Minute) */
export const FALLBACK_WEIGHT = 0.20;

/**
 * Summiert die total_points aller Aktivitäten.
 * Behandelt Strings aus der API defensiv via Number().
 */
export function sumPoints(activities: Activity[]): number {
  return activities.reduce((sum, a) => sum + (Number(a.total_points) || 0), 0);
}

/**
 * Gibt die Punktzahl einer einzelnen Aktivität als Zahl zurück.
 */
export function getActivityPoints(activity: Activity): number {
  return Number(activity.total_points) || 0;
}

/**
 * Formatiert eine Punktzahl zur Anzeige (gerundet, mit "P"-Suffix).
 */
export function formatPoints(points: number): string {
  return `${Math.round(points)}P`;
}

/**
 * Summiert die Gesamtdauer aller Aktivitäten in Minuten (gerundet).
 */
export function sumMinutes(activities: Activity[]): number {
  return Math.round(
    activities.reduce((sum, a) => sum + (Number(a.duration_seconds) || 0), 0) / 60
  );
}
